/*!
 * Copyright (C) Design:Funedikly. All rights reserved.
 */

import * as React from 'react';

export const Devops = () => {
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill="currentColor" d="M22.206 40.5371C28.3729 39.4477 33.4664 38.5463 33.5249 38.5339L33.6312 38.5113L27.8091 31.586C24.6069 27.7772 21.9869 24.646 21.9869 24.628C21.9869 24.5938 27.9988 8.03843 28.0326 7.97949C28.0439 7.95984 32.1352 15.0233 37.9501 25.1018C43.3941 34.5374 47.8824 42.3172 47.9241 42.3901L48 42.5226L29.4967 42.5202L10.9935 42.5179L22.206 40.5371ZM0 38.4253C0 38.4155 2.74337 33.6532 6.09637 27.8424L12.1927 17.2773L19.2974 11.3151C23.2049 8.03592 26.4125 5.34891 26.4254 5.34388C26.4382 5.33911 26.3868 5.46849 26.3111 5.63151C26.2354 5.79454 22.7639 13.2407 18.5965 22.1785L11.0195 38.4292L5.50976 38.4361C2.47939 38.4399 0 38.435 0 38.4253Z"/>
    </svg>
  );
}
